"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomClient = void 0;
// NOTE: used by orval generator
const useCustomClient = ({ url, method, params, data, headers }) => {
    const relPath = url.substring('/lambdas'.length + 1);
    return async function (baseUrl, fetch) {
        const response = await fetch.fetch(`${baseUrl}/${relPath}` + new URLSearchParams(params), {
            method,
            headers,
            ...(data ? { body: JSON.stringify(data) } : {})
        });
        return response.json();
    };
};
exports.useCustomClient = useCustomClient;
exports.default = exports.useCustomClient;
//# sourceMappingURL=fetcher.js.map